import { useApi } from "hooks"
import { useSession } from "hooks";
import { useQuery } from "@tanstack/react-query";

const useGetMe = () => {

  const { apiFetch } = useApi()
  const { secret } = useSession()

  const url = `/me`;

  const getMe = () => {
    return apiFetch({ url })
      .then( res => res.data)
  }

  const options = {
    staleTime: Infinity,
    placeholderData: null,
    enabled: !!secret,
  }

  return useQuery(['user', 'me'], getMe, options)
}

export default useGetMe